import axios from "axios";

const axiosInstance = axios.create({
  // baseURL: "http://192.168.1.73:9098/",
  baseURL: "https://storebh.bhaaraterp.com/",
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("bhaarattoken");
    config.headers = {
      Token: token,
      Authorization: "f76b046791f5a1a349fd0eae1e0064823bemultivendor",
      ...config.headers,
    };
    return config;
  },
  (err) => Promise.reject(err)
);
export default axiosInstance;
